var React = require('react');

function ClockIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"surface7512804"},React.createElement("path",{"style":{"stroke":"none","fillRule":"nonzero","fill":"rgb(40.000001%,66.274512%,95.686275%)","fillOpacity":"1"},"d":"M 12 2.398438 C 6.699219 2.398438 2.398438 6.699219 2.398438 12 C 2.398438 17.300781 6.699219 21.601562 12 21.601562 C 17.300781 21.601562 21.601562 17.300781 21.601562 12 C 21.601562 6.699219 17.300781 2.398438 12 2.398438 Z M 12.800781 12.800781 L 6.394531 12.800781 C 5.957031 12.800781 5.601562 12.445312 5.601562 12.003906 L 5.601562 11.996094 C 5.601562 11.554688 5.957031 11.199219 6.394531 11.199219 L 11.199219 11.199219 L 11.199219 4.796875 C 11.199219 4.355469 11.554688 4 11.996094 4 L 12.003906 4 C 12.445312 4 12.800781 4.355469 12.800781 4.796875 Z M 12.800781 12.800781 "})));
}

ClockIcon.defaultProps = {"viewBox":"0 0 24 24","width":"24px","height":"24px"};

module.exports = ClockIcon;

ClockIcon.default = ClockIcon;
